import {
  COMPONENT_IMAGEBUTTON
} from "../constants/typeConstants";
import common from "./common";
/**
 * factory function to produce Image Button Component Object
 * @param {String} name
 * @param {Array} children array
 */
export default function (name = "Image_Button", children = []) {
  let obj = {
    name: name,
    type: COMPONENT_IMAGEBUTTON,
    children: children
  };
  return Object.assign(obj, common);
}